import * as Vue from 'vue';
import App from './App.vue';
import Home from './pages/Home.vue';
import AboutAI from './pages/AboutAI.vue';
import Invest from './pages/Invest.vue';
import Investment from './pages/Investment.vue';

import Prediction from './pages/Prediction.vue';
import PredictionBodytype from './pages/prediction/Bodytype.vue';
import PredictionFueltype from './pages/prediction/Fueltype.vue';
import PredictionTrim from './pages/prediction/Trim.vue';
import PredictionYear from './pages/prediction/Year.vue';
import PredictionMileage from './pages/prediction/Mileage.vue';

import Reports from './pages/Reports.vue';

import Statistics from './pages/Statistics.vue';
import StatisticsBrands from './pages/statistics/Brands.vue';
import StatisticsMarketsConsumers from './pages/statistics/MarketsConsumers.vue';
import StatisticsDevices from './pages/statistics/Devices.vue';

import "./style/main.scss";
import * as VueRouter  from 'vue-router';
import api from './api';

const vueApp = Vue.createApp(App);

vueApp.config.globalProperties.$api = api;

const router = VueRouter.createRouter({
    history: VueRouter.createWebHistory(),
    scrollBehavior () {
      return { top: 0 }
    },
    routes: [
        {
            path: '/', 
            name: 'home', 
            component: Home
        },
        {
            path: '/prediction', 
            name: 'prediction', 
            component: Prediction,
            redirect: '/prediction/bodytype',
            children: [
                {
                    path: 'bodytype',
                    name: 'bodytype',
                    component: PredictionBodytype,
                    meta: {
                        pageClass: 'prediction'
                    }
                },
                {
                    path: 'fueltype',
                    name: 'fueltype',
                    component: PredictionFueltype,
                    meta: {
                        pageClass: 'prediction'
                    }
                },
                {
                    path: 'trim',
                    name: 'trim',
                    component: PredictionTrim,
                    meta: {
                        pageClass: 'prediction'
                    }
                },
                {
                    path: 'year',
                    name: 'year',
                    component: PredictionYear,
                    meta: {
                        pageClass: 'prediction'
                    }
                },
                {
                    path: 'mileage',
                    name: 'mileage',
                    component: PredictionMileage,
                    meta: {
                        pageClass: 'prediction'
                    }
                }
            ]
        },
        {
            path: '/about-ai', 
            name: 'about-ai', 
            component: AboutAI
        },
        {
            path: '/invest', 
            name: 'invest', 
            component: Invest
        },
        {
            path: '/investment', 
            name: 'investment', 
            component: Investment
        },
        {
            path: '/reports', 
            name: 'reports', 
            component: Reports
        },
        {
            path: '/statistics', 
            name: 'statistics', 
            component: Statistics,
            redirect: '/statistics/brands',
            children: [
                {
                    path: 'brands',
                    name: 'brands',
                    component: StatisticsBrands,
                    meta: {
                        pageClass: 'statistics'
                    }
                },
                {
                    path: 'markets-and-consumers',
                    name: 'markets-and-consumers',
                    component: StatisticsMarketsConsumers,
                    meta: {
                        pageClass: 'statistics'
                    }
                },
                {
                    path: 'devices',
                    name: 'devices',
                    component: StatisticsDevices,
                    meta: {
                        pageClass: 'statistics'
                    }
                }
            ]
        }
    ]
});
vueApp.use(router);
vueApp.mount('#app');
